
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse/[slug]",
      function () {
        return require("private-next-pages/browse/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse/[slug]"])
      });
    }
  